import { OAUTH_CALLBACK_PATH } from "@/constants/hashRouterPaths";
import { getSupabaseClient } from "../shared";

export default async function loginWithGoogle(): Promise<void> {
  const supabase = getSupabaseClient();
  // OAuth returns to /auth/callback?code=... (path). hashRouterBootstrap.ts rewrites to #/auth/callback before React mounts.
  const redirectTo = `${window.location.origin}${OAUTH_CALLBACK_PATH}`;

  const { error } = await supabase.auth.signInWithOAuth({
    provider: "google",
    options: {
      redirectTo,
    },
  });

  if (error) {
    throw new Error(error.message || "Failed to start Google login.");
  }
}
